import React from "react";
import { ListGroup } from "reactstrap";

import { Actions, LoggedInState, State } from "../../../types";
import { Job } from "./Job";

type Props = Readonly<{
  abortJob: Actions["abortJob"];
  activeJobId: string | null;
  jobIds: Array<string>;
  jobs: State["jobs"];
  user: LoggedInState["user"];
}>;

export const PopulatedList = ({ abortJob, activeJobId, jobIds, jobs, user }: Props) => {
  return (
    <ListGroup className="border-bottom border-top" flush>
      {
      jobIds.map(id => {
        if (!(id in jobs)) {
          return null;
        }
        let job = jobs[id].data;
        if (jobs[id].override) {
          job = { ...job, ...jobs[id].override };
        }
        let onAbort;
        if (job.claimed_by && job.claimed_by.id === user.id) {
          onAbort = () => {
            abortJob(job.id);
          };
        }
        return <Job active={activeJobId === id} onAbort={onAbort} job={job} key={id} />;
      })}
    </ListGroup>
  );
};
PopulatedList.displayName = "PopulatedList";
